import { createContext, useContext, type ReactNode } from "react"
import type { Settings } from "../../shared/domain"
import type { Api, UserOption } from "./api"
import type { AppShell } from "./shell"

/** O que todas as páginas usam: sessão, API, utilizadores e definições. */
export interface AppData {
  shell: AppShell
  api: Api
  users: UserOption[]
  me: string | null
  settings: Settings
  setSettings(s: Settings): void
  /** Navega dentro da app mantendo o `?token`. */
  go(path: string): void
  toast(kind: "success" | "error" | "info", title: string, description?: string): void
  userName(id: string | null | undefined): string | null
  severityLabel(key: string | null | undefined): string | null
}

const Ctx = createContext<AppData | null>(null)

export function AppDataProvider({ value, children }: { value: AppData; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useApp(): AppData {
  const v = useContext(Ctx)
  if (!v) throw new Error("useApp fora do AppDataProvider")
  return v
}
